// Data seam for the Kanosei Index, mirroring src/data/portfolio.js.

import { request } from './portfolio';

/** The index view: IBKR-only holdings, drift against frozen targets, the
 *  review schedule, and what the next reconstitution would change. */
export const getIndex = ({ refresh = false } = {}) =>
  request(`index${refresh ? '?refresh=1' : ''}`);

/** The index definition — weights per rank, bands, inception. Static, but
 *  served so the frontend never keeps a second copy of the constitution. */
export const getIndexDefinition = () => request('index/definition');

/** The index account's time-weighted return against the S&P 500 and the
 *  NASDAQ Composite, as cumulative percentages from a common start.
 *
 *  Resolves to `{ from, to, series: [{ key, points: [{ date, pct }] }],
 *  unavailable: [{ key, code }] }`. `key` is 'index', 'spx' or 'ndx'. The
 *  index line is absent — and listed in `unavailable` — when its flows could
 *  not be reconciled with the broker's statement. */
export const getBenchmarks = () => request('index/benchmarks');
